import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const AuditoriaService = {
    getAll: async (page = 0, size = 20) => {
        const response = await getAxios().get('/api/auditoria', { params: { page, size } });
        return response.data;
    },
    getByUsuario: async (username) => {
        const response = await getAxios().get(`/api/auditoria/usuario/${username}`);
        return response.data;
    },
    getByModulo: async (modulo) => {
        const response = await getAxios().get(`/api/auditoria/modulo/${modulo}`);
        return response.data;
    }
};
